<template>
  <div class="app">
    <p class="login-pics image1"></p>
    <p class="login-pics image2"></p>
    <p class="login-pics image3"></p>
    <!-- set progressbar -->
    <vue-progress-bar></vue-progress-bar>
    <Toastr ref="toastr"></Toastr>
    <AppHeader />
    <div class="app template-unauthenticated flex-row align-items-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-8">
            <div class="text-group">
              <h1 class="h1-site-name">
                <p>Welcome to</p>
                Client Center
              </h1>
            </div>
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <AppFooter class="unauthenticated-footer" />
  </div>
</template>

<script>
import Toastr from "vue-toastr";
import { mapGetters } from "vuex";
import {
  HeaderUnauth as AppHeader,
  Footer as AppFooter,
} from "../components/";
import { EventBus } from "../event-bus";
import EventModal from "../components/modal/Modal";

import {
  EVENT_TOAST_MESSAGE,
  EVENT_ERROR_TOAST_MESSAGE,
  EVENT_WARNING_TOAST_MESSAGE
} from "../store/events";

export default {
  name: "templateunauthenticated",
  created() {
    EventBus.$on(
      EVENT_TOAST_MESSAGE,
      function (msg) {
        if (!this.$refs.toastr) return;
        this.$refs.toastr.s(msg);
      }.bind(this)
    );
    EventBus.$on(
      EVENT_ERROR_TOAST_MESSAGE,
      function (msg) {
        if (!this.$refs.toastr) return;
        this.$refs.toastr.e(msg);
      }.bind(this)
    );
    EventBus.$on(
      EVENT_WARNING_TOAST_MESSAGE,
      function (msg) {
        if (!this.$refs.toastr) return;
        this.$refs.toastr.w(msg);
      }.bind(this)
    );
  },
  components: {
    AppHeader,
    AppFooter,
    Toastr,
    EventModal
  },
  data() {
    return {
      modalOptions: {
        title: "",
        message: ""
      },
      loading: false
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched;
    },
    ...mapGetters({
      isLoading: "isLoading"
    })
  },
  watch: {
    isLoading(newLoading) {
      if (newLoading) {
        this.$Progress.start();
      } else {
        this.$Progress.finish();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/_core-variables";

.text-group {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.h1-site-name {
  color: $near-black;
  font-size: 32px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.32px;
  margin: 0 0 30px 0;
}
.h1-site-name p{
  color: $grey-1;
  text-align: center;
  font-size: 20px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.6px;
  margin: 0 0 2px 0;
}
.template-unauthenticated {
  margin-top: 100px;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/containers/TemplateUnauthenticated.vue